import React from "react";

export default function ValidationPreview({ validationResult, onCommit, onBack, loading }) {
  const { errors, warnings, summary } = validationResult;
  const blocking = errors.filter(e => e.type === "BLOCKING");
  // COSMETIC ONLY. hasBlockers greys out the Commit button below; it is not
  // a gate. handleCommit in ImportWizard.jsx calls commitImport
  // unconditionally, so anything that reaches it -- a re-enabled button, a
  // direct call -- is stopped by the BACKEND: import_data.py:1164-1169 aborts
  // the commit with a 400 on any BLOCKING error before the write loop runs.
  // That abort is the actual enforcement. Do not treat this line as one.
  // (A real frontend gate is logged as P-6, out of scope this phase.)
  const hasBlockers = summary.blocking_error_count > 0;

  return (
    <div className="de-panel">
      <h3 style={{ marginBottom: "var(--space-3)" }}>Validation Complete</h3>

      {/* Summary */}
      <div className="vp-summary">
        <div className="vp-summary-row">
          <span className="vp-icon" style={{ color: "var(--color-primary)" }}>&#8635;</span>
          {/* U-5. A MATCH count, not an update count. The preview stops at
              matching -- it never merges documents (handle_validate does not
              call _merge_fields), so it cannot know which matched rows will
              actually change. The commit result reports the split. */}
          <span><strong>{summary.update_count}</strong> tools matched &mdash; updated only if values differ</span>
        </div>
        <div className="vp-summary-row">
          <span className="vp-icon" style={{ color: "var(--color-success)" }}>+</span>
          <span><strong>{summary.create_count}</strong> tools to create</span>
        </div>
        <div className="vp-summary-row">
          <span className="vp-icon" style={{ color: "var(--color-text-secondary)" }}>&#128206;</span>
          <span><strong>{summary.part_numbers_add_count}</strong> part numbers in file</span>
        </div>
        <div className="vp-summary-row">
          <span className="vp-icon" style={{ color: "var(--color-text-secondary)" }}>&#127991;</span>
          <span><strong>{summary.asset_tags_add_count}</strong> asset tags in file</span>
        </div>
        <div className="vp-summary-row vp-summary-total">
          <span><strong>{summary.total_rows}</strong> total rows</span>
        </div>
      </div>

      {/* Blocking errors */}
      {blocking.length > 0 && (
        <div className="vp-issues">
          <div className="vp-issues-header vp-issues-error">
            BLOCKING ERRORS &mdash; {blocking.length}
          </div>
          {blocking.map((e, i) => (
            <div key={i} className="vp-issue-row vp-issue-error">
              <span>{e.message}</span>
            </div>
          ))}
        </div>
      )}

      {/* Warnings */}
      {warnings.length > 0 && (
        <div className="vp-issues">
          <div className="vp-issues-header vp-issues-warning">
            WARNINGS &mdash; {warnings.length}
          </div>
          {warnings.map((w, i) => (
            <div key={i} className="vp-issue-row vp-issue-warning">
              <span>{w.message}</span>
            </div>
          ))}
        </div>
      )}

      {/* Status banner */}
      {hasBlockers && (
        <div className="de-banner de-banner-error" style={{ marginTop: "var(--space-3)" }}>
          Resolve blocking errors before committing.
        </div>
      )}
      {!hasBlockers && blocking.length === 0 && warnings.length === 0 && (
        <div className="de-banner de-banner-success" style={{ marginTop: "var(--space-3)" }}>
          No issues found &mdash; ready to commit.
        </div>
      )}

      <div className="iw-footer" style={{ marginTop: "var(--space-4)" }}>
        <button className="btn btn-secondary" onClick={onBack}>
          &larr; Back to Mapper
        </button>
        <button
          className="btn btn-primary"
          disabled={hasBlockers || loading}
          onClick={onCommit}
        >
          {loading ? "Starting..." : "Commit Import \u2192"}
        </button>
      </div>
    </div>
  );
}
